import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { SettingsToggle } from 'modules/performance_process/components/review/settings/SettingsToggle'

export type TypeSettingsVisibility = {
  earlyAccessToAnswersForManagers: boolean
  restrictAnswersVisibilityToReportees: boolean
  anonymousPeerEvaluationForTarget: boolean
}

type Props = {
  settings: TypeSettingsVisibility
  disabled: boolean
  onSettingToggled: (setting: keyof TypeSettingsVisibility, enabled: boolean) => void
}

export const SettingsVisibility: React.FC<Props> = ({ settings, disabled, onSettingToggled }) => {
  return (
    <Box gap="s32">
      <SettingsToggle
        title={i18n.t(
          'performance_process.reviews.visibility_section.early_access_managers_toggle'
        )}
        disabled={disabled}
        value={settings.earlyAccessToAnswersForManagers}
        onChange={(value) => onSettingToggled('earlyAccessToAnswersForManagers', value)}
        description={i18n.t(
          'performance_process.reviews.visibility_section.early_access_managers_toggle_description'
        )}
      />
      <SettingsToggle
        title={i18n.t('performance_process.reviews.visibility_section.restrict_results_toggle')}
        disabled={disabled}
        value={settings.restrictAnswersVisibilityToReportees}
        onChange={(value) => onSettingToggled('restrictAnswersVisibilityToReportees', value)}
        description={i18n.t(
          'performance_process.reviews.visibility_section.restrict_results_toggle_description'
        )}
      />
      <SettingsToggle
        value={settings.anonymousPeerEvaluationForTarget}
        onChange={(value) => onSettingToggled('anonymousPeerEvaluationForTarget', value)}
        disabled={disabled}
        title={i18n.t(
          'performance_process.reviews.visibility_section.anonymous_peer_evaluation_for_target'
        )}
        description={i18n.t(
          'performance_process.reviews.visibility_section.anonymous_peer_evaluation_for_target_description'
        )}
      />
    </Box>
  )
}
